export default class Main {
    constructor(root) {
        this.root = root;

        this.instanceId   = root.instanceId;
        this.config       = root.config;
        this.input        = root.input;
        this.sheet        = root.sheet;
        this.dateSelector = root.dateSelector;

        this.mobile = false;
        this.showed = false;
        this.builded = false;
        this.firstPositioning = true;

        this.calendarIndent = 0;

        this.$calendar = $('<div class="f-calendar"></div>');
        this.$overlay = $('<div class="f-calendar__overlay"></div>');
        this.$holder = $('<div class="f-calendar__holder"></div>');
        this.$container = $('<div class="f-calendar__container"></div>');
        this.$week_days = $('<div class="f-calendar__week-days"></div>');
    }

    checkMobile() {
        this.mobile = $(window).width() <= 767;

        return this.mobile;
    }

    build() {
        const config = this.config.get();

        this.$calendar.attr('calendar-id', this.instanceId);

        this.$calendar.append(this.$overlay);
        this.$container.append(this.$holder);
        this.$calendar.append(this.$container);
        this.$container.append(this.$week_days);

        this.$insertTo = $(config.insertTo);

        if (this.mobile || !this.$insertTo.length) {
            this.$insertTo = $('body');
        }

        // Insert to document
        this.$insertTo.append(this.$calendar);

        this.buildWeekDays();

        this.builded = true;
    }

    setDateSelectorHeader($header) {
        if (!$header) {
            return false;
        }

        this.$container.prepend($header);
        this.$calendar.addClass('f-calendar_has-header');
    }

    buildWeekDays() {
        if (this.builded) {
            return;
        }

        const { locale, dateFormat } = this.config.get();

        // Собираем блок с заголовками дней
        let days = [
            locale.days.su,
            locale.days.mo,
            locale.days.tu,
            locale.days.we,
            locale.days.th,
            locale.days.fr,
            locale.days.sa
        ];

        // Меняем порядок дней исходя из конфига
        if (dateFormat.firstDay !== 0) {
            const partWeek = days.slice(0, dateFormat.firstDay);
            days.splice(0, dateFormat.firstDay);
            days = [...days, ...partWeek];
        }

        // Создаем дни
        days.forEach((day) => {
            const $day = $('<div class="f-calendar__week-days--day"></div>');
            $day.html(day);

            this.$week_days.append($day);
        });
    }

    show() {
        this.showed = true;

        requestAnimationFrame(() => {
            this.$calendar.addClass('f-calendar_opened');
        });
    }

    hide() {
        this.showed = false;

        requestAnimationFrame(() => {
            this.$calendar.removeClass('f-calendar_opened');
        });
    }

    mount() {
        this.$calendar.addClass('f-calendar_mounted');
    }

    toPosition() {
        // Если не отображается, то ничего не делаем
        if (!this.showed) {
            return;
        }

        const position = {
            top: 0,
            left: 0
        };

        // Позиционируем календарь относительно инпута
        if (!this.mobile) {
            // Считаем размеры элемента
            const $element = this.root.input.$element;
            const { $calendar, $insertTo } = this;

            const calendarElRect = $calendar[0].getBoundingClientRect();
            const inputElRect = $element[0].getBoundingClientRect();
            const constraintElRect = $insertTo[0].getBoundingClientRect();
            const constraintElOffsetTop = constraintElRect.top - $insertTo[0].scrollTop;
            const constraintElOffsetLeft = constraintElRect.left - $insertTo[0].scrollLeft;
            const constraintElOffsetBottom = constraintElOffsetTop + $insertTo[0].scrollHeight;

            position.top = inputElRect.top - constraintElOffsetTop;
            position.left = inputElRect.left - constraintElOffsetLeft;

            if (this.firstPositioning) {
                const pad = 10;
                const bottomSpace = constraintElOffsetBottom - inputElRect.bottom - pad;

                // bottom position
                if (bottomSpace > calendarElRect.height) {
                    this.calendarIndent = inputElRect.height;
                }
                // top position
                else if (inputElRect.top - constraintElOffsetTop - pad > calendarElRect.height) {
                    this.calendarIndent = -calendarElRect.height;
                }
                // center position
                else {
                    this.calendarIndent = inputElRect.height + (calendarElRect.height - bottomSpace) * -1;
                }

                this.firstPositioning = false;
            }

            position.top += this.calendarIndent;
        }

        this.$calendar.css({
            top: `${ position.top }px`,
            left: `${ position.left }px`
        });
    }

    destroy() {
        this.$calendar.removeClass('f-calendar_mounted');
        // Не убиваем события добавленные через Listener
        this.$calendar.detach();
    }
}
